import { css } from '@emotion/react'
import { HeadingSection, HFlow, VFlow } from 'bold-ui'
import { blue, gray, green, red, yellow } from 'bold-ui/lib/styles/colors'
import { Box } from 'components/Box'
import { ErrorField } from 'components/form'
import { RadioFieldContainer } from 'components/form/field/RadioFieldContainer'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import theme from 'config/theme'
import { ClassificacaoRisco } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

export interface ClassificacaoRiscoButtonGroupProps {
  name: MetaPath<ClassificacaoRisco>
}

export function ClassificacaoRiscoButtonGroup({ name }: ClassificacaoRiscoButtonGroupProps) {
  const { meta } = usePecField({ name })
  const classes = createStyles()

  return (
    <HeadingSection level={3} vSpace={8} title={<RequiredLabel label='Classificação de risco/Vulnerabilidade' />}>
      <Box style={meta.submitFailed && meta.error ? classes.box : null}>
        <HFlow hSpacing={3.5}>
          <VFlow>
            <div css={classes.container}>Não aguda</div>
            <RadioFieldContainer
              name={name}
              value={ClassificacaoRisco.PEC_NAO_AGUDA}
              style={[classes.card, classes.naoAguda]}
              label='Não aguda'
            />
          </VFlow>
          <VFlow>
            <div css={classes.container}>Aguda</div>
            <HFlow hSpacing={1.5}>
              <RadioFieldContainer
                name={name}
                value={ClassificacaoRisco.PEC_BAIXA}
                style={[classes.card, classes.baixa]}
                label='Baixa'
              />
              <RadioFieldContainer
                name={name}
                value={ClassificacaoRisco.PEC_INTERMEDIARIA}
                style={[classes.card, classes.intermediaria]}
                label='Intermediária'
              />
              <RadioFieldContainer
                name={name}
                value={ClassificacaoRisco.PEC_ALTA}
                style={[classes.card, classes.alta]}
                label='Alta'
              />
            </HFlow>
          </VFlow>
        </HFlow>
      </Box>
      <div
        css={css`
          padding-bottom: 1rem;
          padding-top: 0.5rem;
        `}
      >
        <ErrorField name={name} />
      </div>
    </HeadingSection>
  )
}

const createStyles = () => ({
  card: css`
    width: 10rem;
    height: 4rem;
    font-weight: bold;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    &:focus {
      box-shadow: none;
    }
  `,

  naoAguda: css`
    background: ${blue.c90};
    color: ${blue.c40};
    border: 0.07rem solid ${blue.c40};
    &:hover {
      background-color: ${blue.c60};
    }
  `,

  baixa: css`
    background: ${green.c90};
    color: ${green.c40};
    border: 0.07rem solid ${green.c40};
    &:hover {
      background-color: ${green.c80};
    }
  `,

  intermediaria: css`
    background: ${yellow.c90};
    color: ${yellow.c40};
    border: 0.07rem solid ${yellow.c40};
    &:hover {
      background-color: ${yellow.c80};
    }
  `,

  alta: css`
    background: ${red.c90};
    color: ${red.c40};
    border: 0.07rem solid ${red.c40};
    &:hover {
      background-color: ${red.c80};
    }
  `,

  container: css`
    text-align: center;
    background-color: ${gray.c90};
    border: 0rem;
    padding: 0.2rem;
  `,

  box: css`
    border: solid 1px ${theme.pallete.status.danger.main};
  `,
})
